module.exports = __webpack_public_path__ + "static/media/AdLabs.11bdcbf4.svg";